import { Types } from "../actions/CheckItemGroupActions";

const initialState = {
    itemGroupList: {},
    itemList: {},
    itemListByGroupId: {},
    plannedItemGroupList: {},
    plannedItemList: {},
    plannedItemListByGroupId: {},
    isTaskUpdatedCheckItemGroup: false,
    plannedCheckItemFiles: null,
    autonomousCheckItemFiles: null,
};

export const CheckItemGroupReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_ITEMGROUPLIST:
            return {
                ...state,
                itemGroupList: action.payload || state.itemGroupList,
            };
        case Types.SET_ITEMLIST:
            return {
                ...state,
                itemList: action.payload || state.itemList,
            };
        case Types.SET_ITEMSBYGROUP:
            return {
                ...state,
                itemListByGroupId: action.payload || state.itemListByGroupId,
            };
        case Types.SET_PLANNED_ITEMGROUPLIST:
            return {
                ...state,
                plannedItemGroupList: action.payload || state.plannedItemGroupList,
            };
        case Types.SET_PLANNED_ITEMLIST:
            return {
                ...state,
                plannedItemList: action.payload || state.plannedItemList,
            };
        case Types.SET_PLANNED_ITEMSBYGROUP:
            return {
                ...state,
                plannedItemListByGroupId: action.payload || state.plannedItemListByGroupId,
            };
        case Types.IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdatedCheckItemGroup: true,
            };
        case Types.SET_PLANNED_CHECK_ITEM_FILES:
            return {
                ...state,
                plannedCheckItemFiles: action.payload || state.plannedCheckItemFiles,
            };
        case Types.SET_AUTONOMOUS_CHECK_ITEM_FILES:
            return {
                ...state,
                autonomousCheckItemFiles: action.payload || state.autonomousCheckItemFiles,
            };
        case Types.RESET_IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdatedCheckItemGroup: false,
            };
        default:
            return state;
    }
};
